import s from "./fourthSlide.module.css";
import {useFourthSlide} from "./useFourthSlide";
import {
    SSMFourthSlideMobileStaticUnityPreview, SSMFourthSlideMobileUnityPreviewVideo,
    SSMFourthSlideStaticUnityPreview,
    SSMFourthSlideUnityPreview,
    SSMFourthSlideUnityPreviewVideo,
    SSMPlayIcon
} from "../../../../assets";
import ProgressBar from "../ProgressBar";
import {Fragment} from "preact";

const FourthSlide = (props) => {
    // Destructured props
    const {
        currentSlide,
        handleCurrentSlide,
        TOTAL_SLIDES
    } = props;

    // Component logic data
    const componentProps = useFourthSlide({
        currentSlide,
        handleCurrentSlide
    });

    // Destructured component logic data
    const {
        hasFinished,
        handleVideoEnd,
    } = componentProps;

    // The actual video player
    const player = (
        <Fragment>
            <video
                key={currentSlide}
                src={SSMFourthSlideUnityPreviewVideo}
                autoPlay={true}
                loop={false}
                onEnded={() => handleVideoEnd(true)}
                className={`!hidden lg:!flex ${s.video}`}
                muted={true}
            />
            <video
                key={currentSlide + 1}
                src={SSMFourthSlideMobileUnityPreviewVideo}
                autoPlay={true}
                loop={false}
                onEnded={() => handleVideoEnd(true)}
                className={`!flex lg:!hidden ${s.video}`}
                muted={true}
            />
        </Fragment>
    );

    return (
        <div className={`w-full h-full ${s.root}`}>
            {/* Backdrop */}
            <div
                className={`w-full h-full absolute top-0 left-0 z-10 pointer-events-none transition-all duration-300 bg-black ${currentSlide > 3 ? "opacity-50" : "opacity-0"}`} />

            <div className={`absolute w-full h-full left-0 top-0`}>
                <div className={`w-full h-full relative z-0`}>
                    {player}
                    <img
                        src={SSMFourthSlideStaticUnityPreview}
                        alt="Static unity preview"
                        className={`hidden lg:block ${s.staticUnityPreview} ${hasFinished ? "opacity-100" : "opacity-0"}`}
                    />
                    <img
                        src={SSMFourthSlideMobileStaticUnityPreview}
                        alt="Static unity preview"
                        className={`lg:hidden ${s.staticUnityPreview} ${hasFinished ? "opacity-100" : "opacity-0"}`}
                    />
                </div>
            </div>
            <div className={`container-fluid w-full h-full`}>
                <div
                    className={`sabin-container h-full pointer-events-none relative transition-all duration-150 ${currentSlide > 3 && "hidden"}`}>
                    <ProgressBar
                        currentSlide={currentSlide}
                        handleCurrentSlide={handleCurrentSlide}
                        TOTAL_SLIDES={TOTAL_SLIDES}
                    />
                </div>
            </div>
        </div>
    )
}

export default FourthSlide;
